import React from 'react';

const Method = (props) => {
    if (props.white) {
        return (
            <div>
                <div className="px-4 py-2 bg-gray-600 rounded-top">
                    {props.title}
                </div>
                <div className="px-4 py-2 bg-gray-400 rounded-bottom"
                     style={{fontFamily:'monospace',fontSize:14}}>
                    {props.children}
                </div>
            </div>
        )
    }
    return (
        <div>
            <div className="px-4 py-2 bg-dark-dark rounded-top">
                {props.title}
            </div>
            <div className="px-4 py-2 bg-dark-light rounded-bottom text-white-50"
                 style={{fontFamily:'monospace',fontSize:14}}>
                {props.children}
            </div>
        </div>
    )
};

export default Method
